'use strict'; // TODO: Remove from `core-js@4`

var $ = require('../internals/export');

var ObjectIterator = require('../internals/object-iterator'); // `Object.iterateEntries` method
// https://github.com/tc39/proposal-object-iteration


$({
  target: 'Object',
  stat: true,
  forced: true
}, {
  iterateEntries: function iterateEntries(object) {
    return new ObjectIterator(object, 'entries');
  }
});